import i18n from '../translations';

export enum TopicTypes {
  STRESS = 'stress',
  SLEEP = 'sleep',
  EMOTIONS = 'emotions',
  MINDFULNESS = 'mindfulness',
  SELFREFLECTION = 'self-reflection',
}

export default [
  {
    value: TopicTypes.STRESS,
    label: i18n.t('v2.global.chip_label_topic_relaxation'),
  },
  {
    value: TopicTypes.SLEEP,
    label: i18n.t('v2.global.chip_label_topic_sleep'),
  },
  {
    value: TopicTypes.EMOTIONS,
    label: i18n.t('v2.global.chip_label_topic_emotions'),
  },
  {
    value: TopicTypes.MINDFULNESS,
    label: i18n.t('v2.global.chip_label_topic_mindfulness'),
  },
  {
    value: TopicTypes.SELFREFLECTION,
    label: i18n.t('v2.global.chip_label_topic_self-reflection'),
  },
];
